import shopifyDawnGenericDefaults from '../shopify-dawn-generic/config.js';

shopifyDawnGenericDefaults.Widgets.map((w) => {
  if (w.name === 'FilterChips' || w.name === 'Facets' || w.name === 'FacetDialog') {
    if (w.ignoreFields) {
      w.ignoreFields.push('wheel_tire_diameter');
    } else {
      w.ignoreFields = ['wheel_tire_diameter'];
    }
  }
  return w;
});

const wheelsFields = shopifyDawnGenericDefaults.Widgets.find(
  (w) => w.name === 'FacetBarWheels',
).fields?.filter((f) => f !== 'wheel_diameter');
const tiresFields = shopifyDawnGenericDefaults.Widgets.find((w) => w.name === 'FacetBarTires').fields?.filter(
  (f) => f !== 'tire_rim',
);

export const createMountedPackagesAddToCartWithRedirect =
  (tiresCollectionUrl) => (productId, variantId) => async (e) => {
    const { href } = window.location;

    const redirectPath = href.includes('WheelProductID')
      ? '/cart'
      : window.location.pathname === '/collections/rim-tire-packages'
        ? window.Convermax.getVehicleUrl(`${tiresCollectionUrl}?WheelProductID/${productId}`)
        : null;

    if (redirectPath) {
      e.preventDefault();
      e.stopPropagation();

      const response = await ajaxAddToCart(variantId);

      if (response.ok) {
        window.location.replace(redirectPath);
      } else {
        // check if cart contains product
        // need this case to force redirect when client has this product in cart
        const cartResponse = await ajaxGetCartItems();
        const parsedCardResponse = await cartResponse.json();

        if (parsedCardResponse?.items?.some((i) => i.variant_id === +variantId)) {
          window.location.replace(redirectPath);
        } else {
          console.error(response);
        }
      }
    }
  };

// Fastco is the only vendor that drop ships mounted and balanced packages;
// rim-tire-packages is the "Mounted Packages - Fastco Wheels" collection
window.Convermax.mountedPackagesAddToCartWithRedirect = createMountedPackagesAddToCartWithRedirect(
  '/collections/mounted-packages-fastco-tires/',
);

const cartUrls = window.Convermax.Shopify?.getCartUrls();

async function ajaxAddToCart(id, quantity = 4) {
  const formData = { items: [{ id, quantity }] };

  return fetch(`${cartUrls.add}.js`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(formData),
  });
}

async function ajaxGetCartItems() {
  return fetch(`${cartUrls.root}.js`, {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });
}

const getItemId = ({ getItemId, getVariantId }) => {
  if (window.document.querySelector('body.page-type-product variant-selects')) {
    const variantId = getVariantId();
    if (variantId) {
      return `${variantId}`;
    }
  }

  return getItemId();
};

const InitFunc = () => {
  shopifyDawnGenericDefaults.InitFunc?.();

  const productOptions = window.document.querySelectorAll('body.page-type-product variant-selects input');

  productOptions?.forEach((element) => {
    element.addEventListener('change', () => {
      setTimeout(() => {
        window.Convermax.updateVerifyFitmentWidget(window.Convermax.Shopify.getVariantId());
      }, 300);
    });
  });
};

export default {
  includes: ['shopify-dawn-generic'],
  ...shopifyDawnGenericDefaults,
  InitFunc,
  product: {
    ...shopifyDawnGenericDefaults.product,
    getItemId,
  },
  Widgets: [
    ...shopifyDawnGenericDefaults.Widgets.filter(
      (w) =>
        ![
          'FacetBarWheels',
          'FacetBarTires',
          'HomeVehicleWidget_tab',
          'TirePanel_tab',
          'WheelPanel_tab',
        ].includes(w.name),
    ),
    {
      name: 'FacetBarWheels',
      type: 'FacetBar',
      fields: ['wheel_tire_diameter', ...wheelsFields],
      minFacetCount: 2,
    },
    {
      name: 'FacetBarTires',
      type: 'FacetBar',
      fields: ['wheel_tire_diameter', ...tiresFields],
      minFacetCount: 2,
    },
    {
      name: 'UpsizeDownsizeFacetPanel',
      type: 'FacetPanel',
      fields: ['wheel_tire_diameter'],
      showAllAlways: true,
      disableCollapse: true,
    },
    {
      name: 'WheelTireVehicleInfo',
      useAutoSyncVisualizer: true,
    },
    {
      name: 'HomeVehicleWidget_tab',
      type: 'VehicleWidget',
      location: {
        selector: '#cm-home-ymm',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'fitmentSearch/homeVehicleWidget',
      columnBreakpoint: 795,
    },
    {
      name: 'TirePanel_tab',
      type: 'RequestPanel',
      location: {
        selector: '#cm-home-tire',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: ['wheel_tire_diameter', ...tiresFields],
    },
    {
      name: 'WheelPanel_tab',
      type: 'RequestPanel',
      location: {
        selector: '#cm-home-wheel',
        class: 'cm_vehicle-widget__tabs',
      },
      template: 'HomeWheelTireBar',
      needInitRequest: true,
      selectFields: ['wheel_tire_diameter', ...wheelsFields],
    },
  ],
};
